export default __webpack_public_path__ + "static/media/whyus3.8d77c875.jpg";